import axios from 'axios'
import * as common from './common'
import * as api from './api'

/**
 * IoT服务API封装
 */
export class IotService {
  /**
   * 获取逃费追缴配置
   * @param {string} sid - 会话ID
   * @param {string} version - 版本号
   * @returns {Promise<object>} API响应数据
   */
  static async getEscapeConfig(sid, version = 'v2') {
    try {
      const { data } = await axios({
        url: common.iotUrl + '/uuid/' + api.urlList.advanced_setting.vh_fee_order_escape.query,
        method: 'POST',
        data: {
          sid: sid,
          version: version
        },
        header: {
          'content-type': 'application/json'
        }
      })
      return data
    } catch (e) {
      throw e
    }
  }

  /**
   * 根据SID获取功能特性
   * @param {string} sid - 会话ID
   * @returns {Promise<object>} API响应数据
   */
  static async getFeatureBySid(sid) {
    try {
      const { data } = await axios({
        url: common.iotUrl + '/s2p/' + 'sid.feature.get_by_sid',
        method: 'POST',
        data: {
          sid: sid,
          version: 'v2'
        },
        header: {
          'content-type': 'application/json'
        }
      })
      return data
    } catch (e) {
      throw e
    }
  }

  /**
   * 获取广告配置
   * @param {string} sid - 会话ID
   * @returns {Promise<object>} 广告配置信息
   */
  static async queryADConfig(sid) {
    try {
      const data = await this.getFeatureBySid(sid)
      
      if (data.code === 10000) {
        console.log(data, '获取关闭广告配置')
        return data.info
      } else {
        throw new Error({ code: data.code, msg: data.msg })
      }
    } catch (e) {
      throw e
    }
  }

  /**
   * 查询进出场详情
   * @param {object} params - 查询参数
   * @returns {Promise<object>} API响应数据
   */
  static async queryInOutDetail(params) {
    try {
      const { data } = await axios({
        url: common.iotUrl + '/s2p/' + api.urlList.query_in_out_detail,
        method: 'POST',
        data: params,
        header: {
          'content-type': 'application/json'
        }
      })
      return data
    } catch (e) {
      throw e
    }
  }

  /**
   * 通用UUID接口调用
   * @param {string} uuid - UUID
   * @param {object} params - 请求参数
   * @returns {Promise<object>} API响应数据
   */
  static async callUuidApi(uuid, params) {
    try {
      const { data } = await axios({
        url: common.iotUrl + '/uuid/' + uuid,
        method: 'POST',
        data: params,
        header: {
          'content-type': 'application/json'
        }
      })
      return data
    } catch (e) {
      throw e
    }
  }

  /**
   * 通用S2P接口调用
   * @param {string} endpoint - 端点
   * @param {object} params - 请求参数
   * @returns {Promise<object>} API响应数据
   */
  static async callS2pApi(endpoint, params) {
    try {
      const { data } = await axios({
        url: common.iotUrl + '/s2p/' + endpoint,
        method: 'POST',
        data: params,
        header: {
          'content-type': 'application/json'
        }
      })
      return data
    } catch (e) {
      throw e
    }
  }
}
